import { Fragment, useState, useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, DatePicker, Form, Input, Radio, TreeSelect, Switch, TimePicker, Image, message, InputNumber, Alert, Upload, Space } from 'antd';
import { pageFormItemLayout, pageFormItemWithoutLabelGridLayout } from '@utils/property';
import dayjs from 'dayjs';
import { fileApi, liveConferencehallsApi, saveLiveApi, getLiveInfoApi, editLiveApi } from '@services/Conference';
import RichEditor from '@components/common/RichEditor';
import './index.less';
import config from '@config';
import { emptyRichText } from '@/utils/utils';
import PageHeader from '@components/PageHeader/PageHeader';
import { CONFERENCE_WORKSPACE_PARENT_PATH, CONFERENCE_WORKSPACE_ROUTE_BASE } from '@/layouts/conferenceWorkspaceConfig';
const option = { headers: { 'Content-Type': 'multipart/form-data' } };

export default function Live() {
    const navigate = useNavigate();

    const params = useParams();
    const conferenceId = parseInt(params?.id) || 0; // 会议项目 ID

    const liveId = parseInt(params?.liveId) || 0; // 直播 ID

    const [form] = Form.useForm();

    const [title, setTitle] = useState(undefined);

    const [introduce, setIntroduce] = useState(undefined);

    const [conferenceList, setConferenceList] = useState([]);

    const [fileList, setFileList] = useState([]);
    const [coverList, setCoverList] = useState([]);
    const [wxCoverList, setWxCoverList] = useState([]);
    const [oneData, setOneData] = useState(false);
    const [days, setDays] = useState(undefined);
    const [startTime, setStartTime] = useState(undefined);
    const [endTime, setEndTime] = useState(undefined);
    const [switchCase, setSwitchCase] = useState(undefined);
    const [pull, setPull] = useState(false);

    const onFinish = values => {
        if (values.conferenceSiteHidden === undefined) values.conferenceSiteHidden = 0;
        if (values.healthcarePlatformHidden === undefined) values.healthcarePlatformHidden = 1;
        if (values.replayEnabled === undefined) values.replayEnabled = 1;
        if (values.hiddenComment === undefined) values.hiddenComment = 0;
        if (values.commentEnabled === undefined) values.commentEnabled = 1;
        if (values.shareInfoEnabled === undefined) values.shareInfoEnabled = 0;
        if (values.hallsId === null) values.hallsId = 0;
        values.pullStreamLive = Number(values.pullStreamLive) === 1 ? 1 : 0;
        values.startTime = days + startTime;
        values.endTime = days + endTime;
        values.conferenceId = Number(params.id);
        values.description = emptyRichText(values.description);
        // replaySettings 序列化为 JSON 字符串后提交
        if (values.replaySettings) {
            values.replaySettings = JSON.stringify(values.replaySettings);
        }
        console.log(dayjs(`${days} ${endTime}`).valueOf(), new Date().getTime());
        if (endTime && dayjs(`${days} ${endTime}`).isBefore(dayjs(`${days} ${startTime}`))) {
            message.warning('结束时间不得早于开始时间');
        }
        // else if (dayjs(`${days} ${endTime}`).valueOf() < new Date().getTime()) {
        //     message.warning('结束时间不得早于当前时间')

        // }
        else {
            if (liveId) {
                values.id = liveId;
                editLiveApi(values).then(res => {
                    if (res.status_code === 200) {
                        navigate(`/conf/conferences/${conferenceId}/lives`);
                    }
                });
            } else {
                saveLiveApi(values).then(res => {
                    if (res.status_code === 200) {
                        navigate(`/conf/conferences/${conferenceId}/lives`);
                    }
                });
            }
        }
    };

    const onReset = () => {
        navigate(`/conf/conferences/${conferenceId}/lives`);
    };

    const disabledDate = d => {
        return d && d.isBefore(dayjs().subtract(1, 'day'), 'day');
    };

    const onIntroduceChange = v => {
        setIntroduce(v);
    };

    // 获取上传文件 - 前缀
    const getFileUrl = url => {
        if (url && url.includes('https')) {
            return url;
        }
        if (url && !url.includes('https')) {
            return config.OSS_PREFIX + url;
        }
        return null;
    };

    const imageUploadHandler = useCallback(
        async blobInfo => {
            const formData = new FormData();
            formData.append('file', blobInfo.blob());
            formData.append('type', 14);
            const hide = message.loading('上传中...', 0);
            try {
                const res = await fileApi(formData, option);
                const url = getFileUrl(res.data);
                hide();
                return url;
            } catch (e) {
                hide();
                throw e;
            }
        },
        [getFileUrl],
    );

    const checkout = (file, size) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
        // 判断类型
        if (!isJpgOrPng) {
            message.error('只能上传 jpg/png/jpeg 格式');
            setOneData(true);
            return null;
        } else {
            setOneData(false);
        }
        // 判断大小
        const isLtM = file.size / 1024 / 1024 < size;
        if (!isLtM) {
            message.error('图像必须小于' + size + 'MB!');
            setOneData(true);
            return null;
        } else {
            setOneData(false);
        }
        return isJpgOrPng && isLtM;
    };

    // 分享图
    const shareImageFile = {
        name: 'shareImageFile',
        customRequest: info => {
            const formData = new FormData();
            formData.append('file', info.file); //名字和后端接口名字对应
            formData.append('type', 14);
            if (!oneData) {
                fileApi(formData, option).then(res => {
                    if (!res) {
                        message.error('上传文件失败！！');
                        return false;
                    }
                    if (res.status_code === 200) {
                        setFileList([getFileUrl(res.data)]);
                        form.setFieldValue('shareImageUrl', getFileUrl(res.data));
                    }
                });
            } else {
                form.setFieldValue('shareImageUrl', undefined);
            }
        },
    };

    //封面
    const beforeCropCheck = (v, bool, type) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = event => {
                var txt = event.target.result;
                var img = document.createElement('img');
                img.src = txt;
                img.onload = () => {
                    if (type === 3) {
                        if (img.width < 500) {
                            bool && message.warning('图片宽度小于500像素');
                            resolve(false);
                        } else if (img.height < 400) {
                            bool && message.warning('图片高度小于400像素');
                            resolve(false);
                        } else {
                            resolve(true);
                        }
                    } else {
                        if (img.width < 750) {
                            bool && message.warning('图片宽度小于750像素');
                            resolve(false);
                        } else if (img.height < 422) {
                            bool && message.warning('图片高度小于422像素');
                            resolve(false);
                        } else {
                            resolve(true);
                        }
                    }
                };
            };
            reader.readAsDataURL(v);
        });
    };

    // 图片上传
    const fileUpload = (info, type) => {
        const formData = new FormData();
        formData.append('file', info.file); //名字和后端接口名字对应
        formData.append('type', 14);
        if (!oneData) {
            fileApi(formData, option).then(res => {
                if (!res) {
                    message.error('上传文件失败！！');
                    return false;
                }
                if (res.status_code === 200) {
                    // pc封面
                    if (type === 1) {
                        setCoverList([getFileUrl(res.data)]);
                        form.setFieldValue('cover', getFileUrl(res.data));
                        form.setFields([{ name: 'cover', errors: null }]);
                    }
                    // 移动端封面
                    if (type === 2) {
                        setWxCoverList([getFileUrl(res.data)]);
                        form.setFieldValue('wxCover', getFileUrl(res.data));
                        form.setFields([{ name: 'wxCover', errors: null }]);
                    }
                }
            });
        } else {
            // pc封面
            if (type === 1) {
                form.setFieldValue('cover', undefined);
            }
            // 移动端封面
            if (type === 2) {
                form.setFieldValue('wxCover', undefined);
            }
        }
    };

    const dateChange = (value, valueString, type) => {
        if (type === 'day') {
            setDays(valueString);
        } else if (type === 'minute') {
            setStartTime(valueString[0] + ':00');
            setEndTime(valueString[1] + ':00');
        }
    };

    const hideChange = (checked, type) => {
        let obj;
        switch (type) {
            case 'conferenceSiteHidden': {
                const conferenceSiteHidden = Number(!checked);
                form.setFieldValue(type, conferenceSiteHidden);
                obj = {
                    ...switchCase,
                    conferenceSiteHidden: checked,
                };
                setSwitchCase({ ...obj });
                break;
            }
            case 'healthcarePlatformHidden': {
                const healthcarePlatformHidden = Number(!checked);
                form.setFieldValue(type, healthcarePlatformHidden);
                obj = {
                    ...switchCase,
                    healthcarePlatformHidden: checked,
                };
                setSwitchCase({ ...obj });
                break;
            }
            case 'replayEnabled': {
                const replayEnabled = Number(checked);
                form.setFieldValue(type, replayEnabled);
                obj = {
                    ...switchCase,
                    replayEnabled: checked,
                };
                setSwitchCase({ ...obj });
                break;
            }
            case 'hiddenComment': {
                const hiddenComment = Number(!checked);
                form.setFieldValue(type, hiddenComment);
                obj = {
                    ...switchCase,
                    hiddenComment: checked,
                };
                setSwitchCase({ ...obj });
                break;
            }
            case 'commentEnabled': {
                const commentEnabled = Number(checked);
                form.setFieldValue(type, commentEnabled);
                obj = {
                    ...switchCase,
                    commentEnabled: checked,
                };
                setSwitchCase({ ...obj });
                break;
            }
            default:
                break;
        }
    };

    const changehalls = v => {
        if (v === undefined) {
            form.setFieldValue('hallsId', null);
        }
    };

    const changePullStreamLive = value => {
        setPull(value);
    };

    useEffect(() => {
        liveConferencehallsApi({ conferenceId: params.id, hidden: 1 }).then(res => {
            if (res.status_code === 200) {
                res.data = res.data.map(item => {
                    const newItem = { ...item };
                    // 被选中 || 存在子会议时，当前会议禁止选择
                    if (item.isSelect || (item.secondHallsList && item.secondHallsList.length)) {
                        newItem.disabled = true;
                    }
                    if (item.secondHallsList && item.secondHallsList.length) {
                        newItem.secondHallsList = item.secondHallsList.map(i => ({ ...i, disabled: i.isSelect }));
                    }
                    return newItem;
                });
                console.log(res.data);
                setConferenceList(res.data);
            }
        });
    }, []);

    useEffect(() => {
        if (liveId) {
            getLiveInfoApi({ id: liveId }).then(res => {
                if (res.status_code === 200) {
                    setTitle(res.data.name);
                    // replaySettings 为 JSON 字符串，回显前先解析
                    if (res.data.replaySettings && typeof res.data.replaySettings === 'string') {
                        try {
                            res.data.replaySettings = JSON.parse(res.data.replaySettings);
                            // vip_only_after_days：正整数映射为 30（直播结束30天后生效），否则置为 0（立即生效）
                            const limit = res.data.replaySettings?.limit;
                            if (limit) {
                                limit.vip_only_after_days = limit.vip_only_after_days > 0 ? 30 : 0;
                            }
                        } catch {
                            res.data.replaySettings = undefined;
                        }
                    }
                    form.setFieldsValue(res.data);
                    setPull(res.data.pullStreamLive);
                    const start = dayjs(res.data.startTime);
                    const end = dayjs(res.data.endTime);
                    const days = dayjs(res.data.startTime).startOf('day');
                    const minutes = [start, end];
                    form.setFieldValue('time', minutes);
                    form.setFieldValue('date', days);
                    form.setFieldValue('cover', res.data.cover);
                    if (res.data.hallsId !== 0) {
                        form.setFieldValue('hallsId', res.data.hallsId);
                    } else {
                        form.setFieldValue('hallsId', null);
                    }
                    setDays(days.format('YYYY-MM-DD'));
                    setStartTime(start.format('HH:mm:00'));
                    setEndTime(end.format('HH:mm:00'));
                    if (res.data?.shareImageUrl) {
                        setFileList([res.data.shareImageUrl]);
                        form.setFieldValue('shareImageUrl', res.data.shareImageUrl);
                    }

                    if (res.data.cover) {
                        setCoverList([res.data.cover]);
                        form.setFieldValue('cover', res.data.cover);
                    }
                    if (res.data.wxCover) {
                        setWxCoverList([res.data.wxCover]);
                        form.setFieldValue('wxCover', res.data.wxCover);
                    }

                    setSwitchCase({
                        conferenceSiteHidden: res.data.conferenceSiteHidden === 1 ? false : true,
                        healthcarePlatformHidden: res.data.healthcarePlatformHidden === 1 ? false : true,

                        replayEnabled: res.data.replayEnabled === 1 ? true : false,
                        hiddenComment: res.data.hiddenComment === 1 ? false : true,

                        commentEnabled: res.data.commentEnabled === 1 ? true : false,
                    });
                }
            });
        } else {
            setSwitchCase({
                conferenceSiteHidden: true,
                healthcarePlatformHidden: false,

                replayEnabled: true,
                hiddenComment: true,

                commentEnabled: true,
            });
        }
    }, []);

    useEffect(() => {
        document.title = liveId ? '编辑直播-医会议' : '新增直播-医会议';
    }, [liveId]);

    return (
        <Fragment>
            <PageHeader
                title={
                    <>
                        <i className="bi bi-chevron-left page-header-back-btn" onClick={() => navigate(`${CONFERENCE_WORKSPACE_ROUTE_BASE}/${conferenceId}/lives`)} />
                        <span>{liveId ? '编辑直播' : '新增直播'}</span>
                    </>
                }
                breadcrumb={[
                    { label: '医会议', path: CONFERENCE_WORKSPACE_PARENT_PATH },
                    { label: title, path: `${CONFERENCE_WORKSPACE_ROUTE_BASE}/${conferenceId}` },
                    { label: '直播管理', path: `${CONFERENCE_WORKSPACE_ROUTE_BASE}/${conferenceId}/lives` },
                ]}
            />

            <div className="page-route-body conference-live-page">
                <div className="main-content-body">
                    <Form
                        form={form}
                        {...pageFormItemLayout}
                        onFinish={onFinish}
                        className="conference-live-form"
                        initialValues={{
                            virtualPv: 99,
                            replayEnabled: 1,
                            replaySettings: {
                                limit: {
                                    vip_only_enabled: false,
                                    vip_only_after_days: 0,
                                },
                            },
                        }}
                    >
                        <div className="form-subtitle">基本信息</div>

                        <Form.Item label="直播名称" name="name" rules={[{ required: true, message: '直播名称不能为空' }]}>
                            <Input placeholder="输入直播名称" maxLength={100} showCount />
                        </Form.Item>

                        <Form.Item label="关联会议" name="hallsId" extra="每场会议仅能绑定一场直播，若当前会议已被其他直播绑定将无法选择。">
                            <TreeSelect
                                placeholder="请选择直播所属会议场次"
                                treeData={conferenceList}
                                fieldNames={{
                                    value: 'id',
                                    label: 'name',
                                    children: 'secondHallsList',
                                }}
                                onChange={changehalls}
                                treeDefaultExpandAll
                                allowClear
                            ></TreeSelect>
                        </Form.Item>

                        <Form.Item label="直播时间" className="required liveminute">
                            <Row>
                                <Col>
                                    <Form.Item name="date" rules={[{ required: true, message: '直播日期不能为空' }]}>
                                        <DatePicker
                                            style={{ marginRight: 8 }}
                                            // disabledDate={disabledDate}
                                            onChange={(value, valueString) => dateChange(value, valueString, 'day')}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col>
                                    <Form.Item name="time" rules={[{ required: true, message: '直播时间不能为空' }]}>
                                        <TimePicker.RangePicker format="HH:mm:ss" onChange={(value, valueString) => dateChange(value, valueString, 'minute')} />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form.Item>

                        <Form.Item label="PC端直播封面" name="cover" rules={[{ required: true, message: '请上传PC端直播封面' }]} extra="支持JPG/PNG格式，建议尺寸 1500*844px（不小于 750*422px，比例16:9），文件大小不超过2MB">
                            {coverList.length > 0 && <Image width={200} src={coverList[0]} className="share-image-area" alt="PC端直播封面预览" />}
                            <div>
                                <Upload customRequest={e => fileUpload(e, 1)} maxCount={1} fileList={coverList} beforeUpload={file => checkout(file, 2)}>
                                    <Button icon={<i className="bi bi-upload"></i>}>{coverList.length > 0 ? '更改封面' : '上传封面'}</Button>
                                </Upload>
                            </div>
                        </Form.Item>

                        <Form.Item label="初始观看人数" name="virtualPv">
                            <InputNumber style={{ width: '100%' }} />
                        </Form.Item>

                        <Form.Item label="第三方拉流" name="pullStreamLive" valuePropName="checked">
                            <Switch checkedChildren="开" unCheckedChildren="关" onChange={changePullStreamLive} />
                        </Form.Item>

                        {pull ? (
                            <Form.Item label="第三方拉流链接" name="pullStreamLiveUrl" extra="支持RTMP、FLV、HLS、SRT格式直播地址" rules={[{ required: true, message: '直播名称不能为空' }]}>
                                <Input />
                            </Form.Item>
                        ) : (
                            <></>
                        )}

                        <Form.Item label="直播简介" name="description" className="invitationContent">
                            <RichEditor id="live-introduce" mode="full" value={introduce ?? ''} onChange={onIntroduceChange} imageUploadHandler={imageUploadHandler} className="react-editor" />
                        </Form.Item>

                        <div className="form-subtitle">展示设置</div>

                        <Form.Item label="会议官网展示" name="conferenceSiteHidden" extra="控制该直播是否在会议官网展示">
                            <Switch checked={switchCase?.conferenceSiteHidden} onChange={checked => hideChange(checked, 'conferenceSiteHidden')} checkedChildren="显示" unCheckedChildren="隐藏" />
                        </Form.Item>

                        <Form.Item label="健康界平台展示" name="healthcarePlatformHidden" extra="控制该直播是否在健康界平台展示">
                            <Switch checked={switchCase?.healthcarePlatformHidden} onChange={checked => hideChange(checked, 'healthcarePlatformHidden')} checkedChildren="显示" unCheckedChildren="隐藏" />
                        </Form.Item>

                        <Form.Item label="开启回放" name="replayEnabled" extra="控制该直播是否能观看回放，关闭时会议直播不能观看回放，但直播系统正常生成回放">
                            <Switch checked={switchCase?.replayEnabled} onChange={checked => hideChange(checked, 'replayEnabled')} checkedChildren="开启" unCheckedChildren="关闭" />
                        </Form.Item>

                        <Form.Item noStyle shouldUpdate={(prev, curr) => prev.replayEnabled !== curr.replayEnabled}>
                            {({ getFieldValue }) =>
                                getFieldValue('replayEnabled') === 1 ? (
                                    <Form.Item label="直播回放限会员观看" required>
                                        <Form.Item name={['replaySettings', 'limit', 'vip_only_enabled']} valuePropName="checked" extra="开启后，直播回放仅限健康界会员观看" rules={[{ required: true, message: '请选择是否限会员观看' }]} style={{ marginBottom: 0 }}>
                                            <Switch
                                                checkedChildren="开启"
                                                unCheckedChildren="关闭"
                                                onChange={checked => {
                                                    // 初次开启时，若 vip_only_after_days 无值则补默认值 0（立即生效）
                                                    if (checked) {
                                                        const current = form.getFieldValue(['replaySettings', 'limit', 'vip_only_after_days']);
                                                        if (current === undefined || current === null) {
                                                            form.setFieldValue(['replaySettings', 'limit', 'vip_only_after_days'], 0);
                                                        }
                                                    }
                                                }}
                                            />
                                        </Form.Item>
                                        <Form.Item noStyle shouldUpdate={(prev, curr) => prev?.replaySettings?.limit?.vip_only_enabled !== curr?.replaySettings?.limit?.vip_only_enabled}>
                                            {({ getFieldValue: getField }) => {
                                                const vipOnlyEnabled = getField(['replaySettings', 'limit', 'vip_only_enabled']);
                                                return vipOnlyEnabled ? (
                                                    <Form.Item name={['replaySettings', 'limit', 'vip_only_after_days']} style={{ marginTop: 8, marginBottom: 0 }}>
                                                        <Radio.Group>
                                                            <Radio value={0}>立即生效</Radio>
                                                            <Radio value={30}>直播结束30天后生效</Radio>
                                                        </Radio.Group>
                                                    </Form.Item>
                                                ) : null;
                                            }}
                                        </Form.Item>
                                    </Form.Item>
                                ) : null
                            }
                        </Form.Item>

                        <Form.Item label="直播评论展示" name="hiddenComment" extra="控制直播评论区是否在会议直播中展示">
                            <Switch checked={switchCase?.hiddenComment} onChange={checked => hideChange(checked, 'hiddenComment')} checkedChildren="显示" unCheckedChildren="隐藏" />
                        </Form.Item>

                        <Form.Item label="开启用户评论" name="commentEnabled" extra="控制直播评论区用户是否可添加新评论">
                            <Switch checked={switchCase?.commentEnabled} onChange={checked => hideChange(checked, 'commentEnabled')} checkedChildren="开启" unCheckedChildren="关闭" />
                        </Form.Item>

                        <Form.Item
                            label="微信小程序分享卡片"
                            name="wxCover"
                            extra={
                                <>
                                    <div>支持JPG/PNG格式，建议尺寸 1000&times;800px（不小于 500&times;400px），比例5:4，大小不超过2MB</div>
                                    <Alert type="warning" showIcon title="若直播以小程序形式分享，必须上传小程序分享图，否则分享图显示比例会异常" />
                                </>
                            }
                        >
                            {wxCoverList.length > 0 && <Image width={200} src={wxCoverList[0]} className="share-image-area" alt="微信小程序分享卡片图预览" />}
                            <div>
                                <Upload customRequest={e => fileUpload(e, 2)} maxCount={1} fileList={wxCoverList} beforeUpload={file => checkout(file, 2)}>
                                    <Button icon={<i className="bi bi-upload"></i>}>{wxCoverList.length > 0 ? '更改图片' : '上传图片'}</Button>
                                </Upload>
                            </div>
                        </Form.Item>

                        <Form.Item label="分享信息" name="shareInfoEnabled">
                            <Radio.Group defaultValue={0}>
                                <Radio value={0}>官网默认</Radio>
                                <Radio value={1}>单独配置</Radio>
                            </Radio.Group>
                        </Form.Item>

                        <Form.Item noStyle shouldUpdate>
                            {({ getFieldValue }) => {
                                return (
                                    getFieldValue('shareInfoEnabled') === 1 && (
                                        <>
                                            <Form.Item label="分享标题" name="shareTitle" rules={[{ required: true }]}>
                                                <Input placeholder="请输入分享标题" />
                                            </Form.Item>

                                            <Form.Item label="分享描述" name="shareDescription">
                                                <Input placeholder="请输入分享描述" />
                                            </Form.Item>

                                            <Form.Item name="shareImageUrl" label="分享图" rules={[{ required: true, message: '' }]} extra="支持JPG/PNG格式，尺寸300&times;300px（不小于150&times;150px），大小不超过1MB" className="share-image">
                                                {fileList.length > 0 && <Image width={200} src={fileList[0]} className="share-image-area" alt="直播分享图预览" />}
                                                <div>
                                                    <Upload beforeUpload={file => checkout(file, 1)} fileList={fileList} {...shareImageFile} maxCount={1}>
                                                        <Button icon={<i className="bi bi-upload"></i>}>{fileList.length > 0 ? '更改图片' : '上传图片'}</Button>
                                                    </Upload>
                                                </div>
                                            </Form.Item>
                                        </>
                                    )
                                );
                            }}
                        </Form.Item>

                        <div className="page-form-foot-operations">
                            <Space size="large">
                                <Button type="primary" size="large" htmlType="submit">
                                    提交
                                </Button>
                                <Button type="default" size="large" onClick={onReset}>
                                    取消
                                </Button>
                            </Space>
                        </div>
                    </Form>
                </div>
            </div>
        </Fragment>
    );
}
